/**
 * Helper utilities for resolving and validating user edition groups
 */

export function getUserEditionGroups(permissions?: Record<string, any> | null): string[] {
    if (!permissions) return [];
    const groups: string[] = [];

    if (typeof permissions.edition_group === 'string' && permissions.edition_group.trim()) {
        groups.push(permissions.edition_group.trim());
    }

    if (Array.isArray(permissions.edition_groups)) {
        permissions.edition_groups.forEach((g: any) => {
            if (typeof g === 'string' && g.trim()) {
                const trimmed = g.trim();
                if (!groups.some((existing) => existing.toLowerCase() === trimmed.toLowerCase())) {
                    groups.push(trimmed);
                }
            }
        });
    }

    return groups;
}

export function canUserEditReservation(
    user: { id?: number | null; permissions?: Record<string, any> | null } | null | undefined,
    reservation: { tenant_id?: number | null; created_by?: any } | null | undefined,
    tenantId?: number | null,
    creatorUser?: { id?: number | null; permissions?: Record<string, any> | null } | null
): boolean {
    if (!reservation || !user) return false;
    if (tenantId && reservation.tenant_id !== tenantId) return false;

    const editMode = user.permissions?.edit_reservation_mode || 'all';
    if (editMode === 'all') return true;

    const isCreator = Boolean(user.id) && Number(reservation.created_by?.id) === Number(user.id);
    if (isCreator) return true;

    if (editMode === 'group') {
        const userGroups = getUserEditionGroups(user.permissions);
        if (userGroups.length === 0) return false;

        const creatorPerms = creatorUser?.permissions || reservation.created_by?.permissions;
        const creatorGroups = getUserEditionGroups(creatorPerms);
        if (creatorGroups.length === 0) return false;

        return userGroups.some((ug) =>
            creatorGroups.some((cg) => cg.toLowerCase() === ug.toLowerCase())
        );
    }

    return false;
}
